export default __webpack_public_path__ + "static/media/service-consulting.fa755121.png";